import {
    Box,
    Card,
    CardContent,
    Grid2,
    Typography,
  } from "@mui/material";
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  import PageHeader, {
    BreadcrumbsModel,
  } from "../../../../shared/PageHeader/PageHeader";
  import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
  import Button from "../../../../components/Button/Button";
  import { useEffect, useState } from "react";
  import API from "../../../../api/axios";
  import moment from "moment";
  import DataLoader from "../../../../shared/DataLoader/DataLoader";
  import HandleInterviewLink, { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";
  const breadcrumbs: BreadcrumbsModel[] = [
    {
      name: "Interview tracker",
      route: "admin/candidate-interview-tracker",
    },
    { name: "View" },
  ];
  
  const CandidateInterviewTrackerView = () => {
    const [interviewerInfo, setInterviewerInfo] = useState<any>({});
    const [dataLoading, setDataLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const state = useLocation();
    const { id } = useParams();
  
    const getInterviewData = async () => {
      setDataLoading(true);
      try {
        let response = await API.post("/positions/all/applied", {
          offset: 0,
          limit: -1,
          applicationID: id,
          userType:'candidate'
        });
        setInterviewerInfo(response?.data?.data[0]);
      } catch (error) {
        // Failed to fetch interview view data
      } finally {
        setDataLoading(false);
      }
    };
  
    useEffect(() => {
      getInterviewData();
    }, [id]);
  
    const formatTime = (startTime: any, endTime: any) => {
      if (startTime === "NA") {
        return "NA";
      }
  
      return `${moment(startTime, "HH:mm:ss").format("hh:mm A")} - ${moment(
        endTime,
        "HH:mm:ss"
      ).format("hh:mm A")}`;
    };

    return (
      <PageWrapper>
        <PageHeader breadcrumbs={breadcrumbs} title="View">
          <Button
            variant="secondary"
            variantType="contained"
            label="Back"
            onClick={() =>
              navigate("/admin/candidate-interview-tracker", {
                state: state?.state,
              })
            }
          />
        </PageHeader>
        <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
          {dataLoading ? (
            <Box height={"400px"}>
              <DataLoader />
            </Box>
          ) : (
            <CardContent>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Candidate Name</Typography>
                  <Typography variant="subtitle2">
                    {interviewerInfo?.candidate_name || "NA"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Email</Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ wordBreak: "break-word" }}
                  >
                    {interviewerInfo?.candidate_email || "NA"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Mobile</Typography>
                  <Typography variant="subtitle2">
                    {interviewerInfo?.candidate_mobile || "NA"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Position Title</Typography>
                  <Typography variant="subtitle2">
                    {interviewerInfo?.position_name || "NA"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Position Status</Typography>
                  <Typography variant="subtitle2">
                    {interviewerInfo?.application_display_status || "NA"}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Applied Date</Typography>
                  <Typography variant="subtitle2">
                    {handleDate(interviewerInfo?.application_date)}
                  </Typography>
                </Grid2>
                {/* <Grid2 size={{xs: 12, sm: 6, md: 4, lg: 3}} marginBottom={4}>
                  <Typography variant="body1">Invite Title</Typography>
                  <Typography variant="subtitle2">HR Round static</Typography>
                </Grid2> */}
                {interviewerInfo?.scheduled_applications?.length > 0 && (
                  <>
                    <Grid2
                      size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                      marginBottom={4}
                    >
                      <Typography variant="body1">Interview Date</Typography>
                      <Typography variant="subtitle2">
                        {handleDate(interviewerInfo?.scheduled_applications[0]?.slot_date)}
                      </Typography>
                    </Grid2>
                    <Grid2
                      size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                      marginBottom={4}
                    >
                      <Typography variant="body1">Interview Time</Typography>
                      <Typography variant="subtitle2">
                        {formatTime(
                          interviewerInfo?.scheduled_applications[0]
                            ?.start_time || "NA",
                          interviewerInfo?.scheduled_applications[0]?.end_time
                        )}
                      </Typography>
                    </Grid2>
                  </>
                )}
                {interviewerInfo?.scheduled_applications?.length > 0 && (
                  <>
                    <Grid2
                      size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                      marginBottom={4}
                    >
                      <Typography variant="body1">Interview Link</Typography>
                      <Typography variant="subtitle2">
                        <HandleInterviewLink
                          link={
                            interviewerInfo?.scheduled_applications[0]?.webex_link
                          }
                        />
                      </Typography>
                    </Grid2>
                  </>
                )}
                <Grid2
                  size={{
                    xs:12
                  }}
                  marginBottom={4}
                >
                  <Typography variant="body1">Description</Typography>
                  <Typography variant="subtitle2">
                    {interviewerInfo?.additional_notes}
                  </Typography>
                </Grid2>
                <Grid2
                  size={{
                    xs:
                      interviewerInfo?.scheduled_applications?.length > 0
                        ? 6
                        : 12,
                  }}
                  marginBottom={4}
                >
                </Grid2>
              </Grid2>  
            </CardContent>
          )}
        </Card>
      </PageWrapper>
    );
  };
  export default CandidateInterviewTrackerView;
  

  